import { ajaxJson } from 'imports/ajax';
import { 
    map2programObj,
    map2ProgramProgressObj
} from 'imports/mapper';
import { programActionCreators } from 'db/program/program.action'
import { createTypes } from 'redux-create-types';

const namespace = 'my-programs';

export const myProgramsActions = createTypes([
    'toggleSpinner',
    'setError',
    'setProgramsList',
], namespace);

function showSpinner(apiName) {
    return dispatch => {
        dispatch({
            type: myProgramsActions.toggleSpinner,
            payload: true,
            meta: {apiName}
        });
    }
}

function hideSpinner(apiName) {
    return dispatch => {
        dispatch({
            type: myProgramsActions.toggleSpinner,
            payload: false,
            meta: {apiName}
        });
    }
}

function setProgramsList(ids) {
    return dispatch => {
        return dispatch({
            type: myProgramsActions.setProgramsList,
            payload: ids,
        });
    }
}

function getProgramProgressApiFail(err) {
    return dispatch => {
        dispatch({
            type: myProgramsActions.setError,
            payload: err,
        })
        return dispatch(hideSpinner('user-programs'));
    }
}

function getProgramProgressApiSuccess(res, program) {
    return dispatch => {
        const programProgressObj = map2ProgramProgressObj(res.data);
        const calcProgress = Math.trunc((programProgressObj.seenUnitsCount / programProgressObj.totalUnitsCount) * 100) || 0;
        const programObjWithProgress = Object.assign({}, program, {progress: calcProgress});
        dispatch(programActionCreators.save(programObjWithProgress));
    }
}

function getProgramProgressFromApi(program) {
    return dispatch => {
        return ajaxJson.get(`activities/programs/${program.id}/progress`)
        .then(
            res => dispatch(getProgramProgressApiSuccess(res, program)),
            err => dispatch(getProgramProgressApiFail(err)),
        )
    }
}

function saveProgramWithNotVerifiedStatus(program) {
    return dispatch => {
        const programObjWithProgress = Object.assign({}, program, {progress: null});
        return dispatch(programActionCreators.save(programObjWithProgress));
    }
}

function getUserProgramsApiFail(err) {
    return dispatch => {
        dispatch({
            type: myProgramsActions.setError,
            payload: err,
        })
        return dispatch(hideSpinner('user-programs'));
    }
}

function getUserProgramsApiSuccess(res) {
    return dispatch => {
        const programsObj = res.data.map((program) => {
            return map2programObj(program);
        });
        const dispatches = programsObj.map(program => {
            if (program.status === "not-verified") {
                return dispatch(saveProgramWithNotVerifiedStatus(program))
            }
            return dispatch(getProgramProgressFromApi(program));
        });
        return Promise.all(dispatches).then(() => {
            const programIds = programsObj.map(p => (p.id));
            dispatch(hideSpinner('user-programs'));
            return dispatch(setProgramsList(programIds))
        })
    }
}

function getUserProgramsFromApi() {
    return dispatch => {
        dispatch(showSpinner('user-programs'))
        return ajaxJson.get('/users/programs')
        .then(
            res => dispatch(getUserProgramsApiSuccess(res)),
            err => dispatch(getUserProgramsApiFail(err)),
        )
    }
}

export const myProgramsActionCreators = {
    getUserProgramsFromApi,
}